/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import { connect } from 'react-redux';
import ParticipantStatusComponent from './participant.status.component';
import * as actions from '../../actions/participant.status.actions';
import { hideModal } from '../../actions/actions';

export const mapStateToProps = (state, ownProps) => {
  return {
    error: state.participantStatus.error,
    participantFinalStatuses: state.participantStatus.participantStatuses,
    isLoading: state.participantStatus.isLoading,
    currentStatus: state.subject.participantJourney.overallStatus,
    studyGid: state.subject.participantStudy.gid,
    participantId: state.subject.participantJourney.userId,
    participantJourneyGid: state.subject.participantJourney.gid
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    loadParticipantStatuses: () => {
      dispatch(actions.loadParticipantStatuses());
    },
    saveStatus: (payload, studyGid, participantId) => {
      dispatch(actions.saveParticipantStatus(payload, studyGid, participantId));
    },
    resetStatus: (participantJourneyGid, studyGid, payload) => {
      dispatch(actions.resetParticipantStatus(participantJourneyGid, studyGid, payload));
    },
    hide: () => {
      dispatch(hideModal());
    }
  };
};

const ParticipantStatusModalContainer = connect(mapStateToProps, mapDispatchToProps)(ParticipantStatusComponent);

export default ParticipantStatusModalContainer;
